export const environment = {
  apiUrl: 'https://service.tourist.pbstest.net',
  apiKey: 'ALLOWED-APPLICATION',
  webUrl: 'https://tourist.pbstest.net',
};
